import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'
import Template from '../../components/template'
import { useCallback, useEffect, useState } from 'react'
import { getWorkflowConfig } from '../util'
import { DuplicateRow, MetaEntry, WorkflowConfig } from '../../lib/types'
import Loading from '../../components/loading'
import { data } from '../../lib/api'
import ErrorMsg from '../../components/error-msg'
import DuplicatesTable from '../../components/duplicatesTable'

export default function DuplicatesPage() {
    const { id } = useParams()
    const [config, setConfig] = useState<WorkflowConfig | null>(null)
    const [error, setError] = useState<any>()
    const [loading, setLoading] = useState(false)
    const [duplicates, setDuplicates] = useState<DuplicateRow[]>([])
    const [rows, setRows] = useState<any[]>([])
    const [meta, setMeta] = useState<MetaEntry[]>([])
    const [selectedRow, setSelectedRow] = useState<DuplicateRow[]>([])

    useEffect(() => {
        getWorkflowConfig(Number(id))
            .then(setConfig)
            .catch((err) => setError(err.message || err))
    }, [id])

    const getDuplicates = useCallback(() => {
        data.getDuplicates(Number(id))
            .then((results) => {
                setDuplicates(results.duplicates)
                setRows(results.rows)
                setMeta(results.meta)
                setSelectedRow([])
            })
            .catch((err) => {
                setError(err.message || err)
                setLoading(false)
            })
    }, [id])

    const deleteDuplicate = () => {
        data.deleteDuplicates(Number(id), selectedRow).then(() => getDuplicates()).catch(err => setError(err.message || err))
    }

    function handleSelectRow(duplicate: DuplicateRow) {
        setSelectedRow(prev => {
            if (prev.find(item => item.id === duplicate.id)) {
                return prev.filter(item => item.id !== duplicate.id)
            } else {
                return [...prev, duplicate]
            }
        })
    }

    function handleSelectAll() {
        if (selectedRow.length === duplicates.length) {
            setSelectedRow([])
        } else {
            setSelectedRow(duplicates)
        }
    }

    function handleCancelSelection() {
        setSelectedRow([])
    }

    useEffect(() => {
        getDuplicates()
    }, [id, getDuplicates])

    return (
        <Template auth={['admin', 'workflowAdmin']}>
            <div className='mx-20 my-10'>
                <div className='mb-3'>
                    <Link to={'/workflows/' + id}>
                        <i className='lni lni-chevron-left' /> Back to Workflow
                    </Link>
                </div>
                {error && <ErrorMsg error={error} />}
                <h1 className='mb-5'>
                    Duplicate Rows In{' '}
                    <span className='font-bold text-blue-600'>{config?.name}</span>
                </h1>
                {loading && <Loading />}
                {!loading && error && <div>Unable to load table</div>}

                {!loading && !!duplicates.length && meta.length && (
                    <DuplicatesTable data={rows} meta={meta} duplicates={duplicates} selectedRow={selectedRow} deleteDuplicate={deleteDuplicate} handleSelectRow={handleSelectRow} handleCancel={handleCancelSelection} handleSelectAll={handleSelectAll} />
                )}
                {!loading && !duplicates.length && <div>No duplicates for this workflow</div>}
            </div>
        </Template>
    )
}
